export default "__VITE_ASSET__a6db4cd0__$_?react__"